import { render, staticRenderFns } from "./Part.vue?vue&type=template&id=540b0b36&scoped=true"
import script from "./Part.vue?vue&type=script&lang=js"
export * from "./Part.vue?vue&type=script&lang=js"
import style0 from "./Part.vue?vue&type=style&index=0&id=540b0b36&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540b0b36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('540b0b36')) {
      api.createRecord('540b0b36', component.options)
    } else {
      api.reload('540b0b36', component.options)
    }
    module.hot.accept("./Part.vue?vue&type=template&id=540b0b36&scoped=true", function () {
      api.rerender('540b0b36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/Information/components/Part.vue"
export default component.exports